import React from "react";
import styles from "./styles.module.scss"

function Button (props: {type?: "primary" | "default" | "outline" | "link", width?: string, children?: React.ReactNode, onClick?:(e: any) => void, withArrow?: boolean, className?: string }) {
  const {type="primary", onClick, children, withArrow, width, className} = props
  return <button onClick={onClick} className={`${styles[type]} ${styles.button} ${className}`}  style={{width}}>
    <div className={styles.content}>
      <span>{children}</span>
      {withArrow ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="11.707" height="10.707"><path d="M10.293 5.354 5.646 10l.708.707 5.353-5.353L6.354 0l-.708.707 4.647 4.647Z" fillRule="evenodd" fill="currentColor"/><path d="M0 4.854h11v1H0v-1Z" fillRule="evenodd" fill="currentColor"/></svg> : null}
    </div>
  </button>
}

export default Button
